export const OUTCOME_FIELDS = `
  id
  alias
  description
  name
  status
  milestones
  projectId
  createdAt
  updatedAt
`;
